import { render, staticRenderFns } from "./suitch-tracker-status-widget.vue?vue&type=template&id=1a47e058&"
import script from "./suitch-tracker-status-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-tracker-status-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports